import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const profileTimelineGroupCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}.audience-profile-expand{position:relative;display:flex;flex-direction:column;gap:1rem}.audience-profile-expand::before{content:\"\";position:absolute;left:calc(2rem + 10px);top:0;bottom:0;width:2px;background-color:var(--tt-color-gray-400)}";

const ProfileTimelineGroup = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return (h("div", { class: "audience-profile-expand", part: "base" }, h("slot", null)));
  }
  static get style() { return profileTimelineGroupCss; }
}, [1, "tt-profile-timeline-group"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-profile-timeline-group"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-profile-timeline-group":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ProfileTimelineGroup);
      }
      break;
  } });
}

const TtProfileTimelineGroup = ProfileTimelineGroup;
const defineCustomElement = defineCustomElement$1;

export { TtProfileTimelineGroup, defineCustomElement };
